// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gdx/gateway/web/payment/v2/package.proto (package gdx.gateway.web.payment.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Duration, Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { PromoType } from "./promo_pb.js";

/**
 * Describes premium package message.
 *
 * @generated from message gdx.gateway.web.payment.v2.PremiumPackage
 */
export class PremiumPackage extends Message<PremiumPackage> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Package name, SHOULD start with NUMBER, e.g.: `1 week`, `2 months`, etc...
   *
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: bool is_trial = 3;
   */
  isTrial = false;

  /**
   * @generated from field: bool is_popular = 4;
   */
  isPopular = false;

  /**
   * @generated from field: gdx.gateway.web.payment.v2.Price price = 15;
   */
  price?: Price;

  /**
   * @generated from field: gdx.gateway.web.payment.v2.Price price_per_week = 16;
   */
  pricePerWeek?: Price;

  /**
   * Package saving in % relative to most expensive package in list.
   *
   * @generated from field: uint32 savings_percent = 7;
   */
  savingsPercent = 0;

  /**
   * Small descriptive text eg. 1 week etc...
   *
   * @generated from field: string label = 8;
   */
  label = "";

  /**
   * @generated from field: gdx.gateway.web.payment.v2.PremiumPackage next_package = 9;
   */
  nextPackage?: PremiumPackage;

  /**
   * @generated from field: gdx.gateway.web.payment.v2.Offer offer = 10;
   */
  offer?: Offer;

  /**
   * @generated from field: bool is_subscription = 11;
   */
  isSubscription = false;

  constructor(data?: PartialMessage<PremiumPackage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.PremiumPackage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "is_trial", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "is_popular", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 15, name: "price", kind: "message", T: Price },
    { no: 16, name: "price_per_week", kind: "message", T: Price },
    { no: 7, name: "savings_percent", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 8, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "next_package", kind: "message", T: PremiumPackage },
    { no: 10, name: "offer", kind: "message", T: Offer },
    { no: 11, name: "is_subscription", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PremiumPackage {
    return new PremiumPackage().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PremiumPackage {
    return new PremiumPackage().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PremiumPackage {
    return new PremiumPackage().fromJsonString(jsonString, options);
  }

  static equals(a: PremiumPackage | PlainMessage<PremiumPackage> | undefined, b: PremiumPackage | PlainMessage<PremiumPackage> | undefined): boolean {
    return proto3.util.equals(PremiumPackage, a, b);
  }
}

/**
 * Describes credits package message.
 *
 * @generated from message gdx.gateway.web.payment.v2.CreditsPackage
 */
export class CreditsPackage extends Message<CreditsPackage> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: int64 credits_count = 3;
   */
  creditsCount = protoInt64.zero;

  /**
   * @generated from field: bool is_popular = 4;
   */
  isPopular = false;

  /**
   * @generated from field: gdx.gateway.web.payment.v2.Price price = 9;
   */
  price?: Price;

  /**
   * @generated from field: gdx.gateway.web.payment.v2.Offer offer = 6;
   */
  offer?: Offer;

  constructor(data?: PartialMessage<CreditsPackage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.CreditsPackage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "credits_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "is_popular", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "price", kind: "message", T: Price },
    { no: 6, name: "offer", kind: "message", T: Offer },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditsPackage {
    return new CreditsPackage().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditsPackage {
    return new CreditsPackage().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditsPackage {
    return new CreditsPackage().fromJsonString(jsonString, options);
  }

  static equals(a: CreditsPackage | PlainMessage<CreditsPackage> | undefined, b: CreditsPackage | PlainMessage<CreditsPackage> | undefined): boolean {
    return proto3.util.equals(CreditsPackage, a, b);
  }
}

/**
 * Describes package promotion offer.
 *
 * @generated from message gdx.gateway.web.payment.v2.Offer
 */
export class Offer extends Message<Offer> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: uint32 discount_percent = 2;
   */
  discountPercent = 0;

  /**
   * @generated from field: gdx.gateway.web.payment.v2.Price price = 12;
   */
  price?: Price;

  /**
   * applicable to subscription packages only.
   *
   * @generated from field: gdx.gateway.web.payment.v2.Price price_per_week = 13;
   */
  pricePerWeek?: Price;

  /**
   * @generated from field: bool is_free = 5;
   */
  isFree = false;

  /**
   * @generated from field: gdx.gateway.web.payment.v2.PromoType type = 11;
   */
  type = PromoType.INVALID;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at_time = 6;
   */
  expiresAtTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Duration expires_duration = 7;
   */
  expiresDuration?: Duration;

  constructor(data?: PartialMessage<Offer>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.Offer";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "discount_percent", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 12, name: "price", kind: "message", T: Price },
    { no: 13, name: "price_per_week", kind: "message", T: Price },
    { no: 5, name: "is_free", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "type", kind: "enum", T: proto3.getEnumType(PromoType) },
    { no: 6, name: "expires_at_time", kind: "message", T: Timestamp },
    { no: 7, name: "expires_duration", kind: "message", T: Duration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Offer {
    return new Offer().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Offer {
    return new Offer().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Offer {
    return new Offer().fromJsonString(jsonString, options);
  }

  static equals(a: Offer | PlainMessage<Offer> | undefined, b: Offer | PlainMessage<Offer> | undefined): boolean {
    return proto3.util.equals(Offer, a, b);
  }
}

/**
 * Package identity object for payment requests.
 *
 * @generated from message gdx.gateway.web.payment.v2.PackageIdentity
 */
export class PackageIdentity extends Message<PackageIdentity> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string offer_id = 2;
   */
  offerId = "";

  constructor(data?: PartialMessage<PackageIdentity>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.PackageIdentity";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "offer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PackageIdentity {
    return new PackageIdentity().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PackageIdentity {
    return new PackageIdentity().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PackageIdentity {
    return new PackageIdentity().fromJsonString(jsonString, options);
  }

  static equals(a: PackageIdentity | PlainMessage<PackageIdentity> | undefined, b: PackageIdentity | PlainMessage<PackageIdentity> | undefined): boolean {
    return proto3.util.equals(PackageIdentity, a, b);
  }
}

/**
 * Describes package/offer pricing with applied discounts and taxes.
 *
 * @generated from message gdx.gateway.web.payment.v2.Price
 */
export class Price extends Message<Price> {
  /**
   * @generated from field: uint64 base_amount = 1;
   */
  baseAmount = protoInt64.zero;

  /**
   * @generated from field: uint64 discount_amount = 2;
   */
  discountAmount = protoInt64.zero;

  /**
   * @generated from field: uint64 tax_amount = 3;
   */
  taxAmount = protoInt64.zero;

  /**
   * base_amount - discount_amount + tax_amount
   *
   * @generated from field: uint64 total_amount = 4;
   */
  totalAmount = protoInt64.zero;

  /**
   * @generated from field: string currency = 5;
   */
  currency = "";

  constructor(data?: PartialMessage<Price>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.Price";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "base_amount", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "discount_amount", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "tax_amount", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "total_amount", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 5, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Price {
    return new Price().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Price {
    return new Price().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Price {
    return new Price().fromJsonString(jsonString, options);
  }

  static equals(a: Price | PlainMessage<Price> | undefined, b: Price | PlainMessage<Price> | undefined): boolean {
    return proto3.util.equals(Price, a, b);
  }
}

